/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ExternalServiceConfig } from './ExternalServiceConfig.js';
import {
    ExternalServiceConfigFromJSON,
    ExternalServiceConfigFromJSONTyped,
    ExternalServiceConfigToJSON,
} from './ExternalServiceConfig.js';

/**
 * 
 * @export
 * @interface ExternalServiceResponse
 */
export interface ExternalServiceResponse {
    /**
     * 
     * @type {ExternalServiceConfig}
     * @memberof ExternalServiceResponse
     */
    data?: ExternalServiceConfig;
    /**
     * 
     * @type {number}
     * @memberof ExternalServiceResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof ExternalServiceResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ExternalServiceResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof ExternalServiceResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the ExternalServiceResponse interface.
 */
export function instanceOfExternalServiceResponse(value: object): boolean {
    return true;
}

export function ExternalServiceResponseFromJSON(json: any): ExternalServiceResponse {
    return ExternalServiceResponseFromJSONTyped(json, false);
}

export function ExternalServiceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalServiceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ExternalServiceConfigFromJSON(json['data']),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ExternalServiceResponseToJSON(value?: ExternalServiceResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': ExternalServiceConfigToJSON(value['data']),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

